import { Button, Col, Form, Input, type InputRef, Row, Switch } from 'antd'
import { useCallback, useEffect, useRef, type FunctionComponent } from 'react'
import { RegionSelect } from '~/components/RegionSelect'
import { useCreateServerMutation, useUpdateServerMutation } from './mutation'

interface EditServerDrawerProps {
  onSuccess: () => void
  server: any
  courseId: number
}

export const ServerForm: FunctionComponent<EditServerDrawerProps> = ({ onSuccess, server, courseId }) => {
  const createMutation = useCreateServerMutation()
  const updateMutation = useUpdateServerMutation(server?.id)
  const mutation = server == null ? createMutation : updateMutation

  const doEditCourse = useCallback(
    (values) => {
      mutation.mutate(
        {
          ...values,
          course_id: courseId
        },
        {
          onSuccess
        }
      )
    },
    [courseId, mutation, onSuccess]
  )

  const firstInputRef = useRef<InputRef>(null)
  useEffect(() => {
    setTimeout(() => firstInputRef.current?.focus(), 300)
  }, [])

  return (
    <Form layout="vertical" onFinish={doEditCourse} initialValues={server}>
      <Row>
        <Col span={24}>
          <Form.Item
            name="name"
            label="Server name"
            rules={[{ required: true, message: 'Please enter server name' }]}
          >
            <Input ref={firstInputRef} placeholder="Please enter server name" />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Form.Item
            name="region_code"
            label="Location"
            rules={[{ required: true, message: 'Please select the location' }]}
          >
            <RegionSelect />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Form.Item
            name="is_master"
            label="Is Master"
            valuePropName="checked"
          >
            <Switch />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={24}>
          <Button type="primary" htmlType="submit" loading={mutation.isPending} disabled={mutation.isPending}>
            Submit
          </Button>
        </Col>
      </Row>
    </Form>
  )
}
